<div class="justify-content-center">
	<p-breadcrumb class="max-w-full" [model]="items">
		<ng-template pTemplate="item" let-item>
			<ng-container *ngIf="item.routerLink; else elseBlock">
				<a [routerLink]="item.routerLink" class="p-menuitem-link">
					<span [ngClass]="[item.icon ? item.icon : '', 'text-color']"></span>
					<span [ngClass]="[isActive(item) ? 'text-primary font-semibold' : 'text-color']">{{
						item.label
					}}</span>
				</a>
			</ng-container>
			<ng-template #elseBlock>
				<a [href]="item.url">
					<span class="text-color">{{ item.label }}</span>
				</a>
			</ng-template>
		</ng-template>
	</p-breadcrumb>
</div>
